import Svg, { Path } from 'react-native-svg'

export const ManageUsersIcon = ({ height = 24, width = 24, color = '#000' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M7 11a3.1 3.1 0 0 0 .69-.09A5.48 5.48 0 0 1 7.1 5H7a3 3 0 1 0 0 6Zm5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm5 0a3 3 0 0 0 0-6h-.1a5.48 5.48 0 0 1-.59 5.9 3.1 3.1 0 0 0 .69.1Zm-5 1a6 6 0 0 0-6 6 2 2 0 0 0 2 2h8a2 2 0 0 0 2-2 6 6 0 0 0-6-6Zm5.31 0A7.999 7.999 0 0 1 20 18a4.09 4.09 0 0 1-.14 1H20a2 2 0 0 0 2-2 5 5 0 0 0-4.69-5ZM6.69 12A5 5 0 0 0 2 17a2 2 0 0 0 2 2h.14A4.09 4.09 0 0 1 4 18a8 8 0 0 1 2.69-6Z"
      />
    </Svg>
  )
}
